<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" v-shortkey="['esc']" @shortkey="cerrar"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <form @submit.prevent="guardar">
                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3>
                                Actualizar rollo
                            </h3>
                        </div>

                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Nombre</label>
                            <input type="text" id="campo_rollo_nombre_busqueda" class="form-control form-control-sm"
                                v-model="nombre" required>
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Tipo</label>
                            <input type="text" class="form-control form-control-sm" v-model="tipo" required>
                        </div>

                        <div class="col-sm-12 mt-3 mb-3 d-flex justify-content-end">
                            <b-button type="submit" size="sm" variant="outline-dark">Guardar</b-button>
                        </div>
                    </b-row>

                </form>
            </b-container>

        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        name: 'Actualizar',
        props: ['item'],
        data() {
            return {
                nombre: '',
                tipo: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async guardar() {
                let f = {
                    api: `tipo-de-rollos/${this.item.documentId}`,
                    formulario: {
                        nombre: this.nombre.toUpperCase().trim(),
                        tipo: this.tipo.toUpperCase().trim()
                    }
                }

                await this.actualizar_data(f)
                await this.$emit('actualizar')
                this.cerrar()

                this.nombre = ''
                this.tipo = ''

                document.getElementById('campo_rollo_nombre_busqueda').focus()
            },
            ...mapActions(['actualizar_data'])
        },
        mounted() {
            document.getElementById('campo_rollo_nombre_busqueda').focus()
            this.nombre = this.item.nombre
            this.tipo = this.item.tipo
        },
    }
</script>

<style></style>